document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('.section-navigation a');
  const sections = document.querySelectorAll('.navigate-to-section');

  markUnavailableVariants();

  // Smooth scroll on click
  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = link.getAttribute('href').slice(1);
      const target = document.getElementById(targetId);
      if (target) {
        const yOffset = -145;
        const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  });

  // Update active link on scroll
  const activateLinkOnScroll = () => {
    let currentSectionId = '';
    sections.forEach((section) => {
      if (!section.id) return;
      const sectionTop = section.offsetTop - 145; // adjust for nav height
      if (window.scrollY >= sectionTop) {
        currentSectionId = section.id;
      }
    });

    links.forEach((link) => {
      link.classList.toggle('link-styled--active', link.getAttribute('href') === `#${currentSectionId}`);
    });
  };

  window.addEventListener('scroll', activateLinkOnScroll);
  activateLinkOnScroll(); // Run on page load

  function analyzeImageBrightness(img, callback) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
  
    const width = 10; // downscale for speed
    const height = 10;
    canvas.width = width;
    canvas.height = height;
  
    ctx.drawImage(img, 0, 0, width, height);
  
    try {
      const imageData = ctx.getImageData(0, 0, width, height);
      const data = imageData.data;
  
      let r, g, b, avg;
      let colorSum = 0;
  
      for (let i = 0; i < data.length; i += 4) {
        r = data[i];
        g = data[i + 1];
        b = data[i + 2];
        avg = (r + g + b) / 3;
        colorSum += avg;
      }
  
      const brightness = colorSum / (data.length / 4);
      callback(brightness < 128 ? 'dark' : 'light', img);
    } catch (err) {
      console.warn('Image analysis failed (CORS issue?):', img.src);
    }
  }
  
  // Loop through all target images
  document.querySelectorAll('.product__media .product__media-item img').forEach(img => {
    if (img.complete) {
      analyzeImageBrightness(img, (theme, image) => {
        image.closest('.product__media-item').classList.add(theme);
      });
    } else {
      img.onload = () => {
        analyzeImageBrightness(img, (theme, image) => {
          image.closest('.product__media-item').classList.add(theme);
        });
      };
    }
  });
  
});


const atcObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const target = entry.target.closest('.product-wrapper').querySelector('.sticky-atc');
      if (target !== null) {
        entry.isIntersecting ? target.classList.remove('active') : target.classList.add('active');
      }
    });
  },
  {
    threshold: 0.25,
  }
);

if(document.querySelector('#AddToCartButton') != null){
  atcObserver.observe(document.querySelector('#AddToCartButton'));
}
if(document.querySelector('.sticky-atc')) {
  document.querySelector('.sticky-atc').addEventListener('click', () => {
    document.querySelector('.product-form').scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  });
}

if (document.querySelector('.icon__zoom')) {
  const zoom_container = document.querySelector('.gallery-zoom');

  document.querySelectorAll('.product__media-item:not(.media-video)').forEach((item) => {
    // Attach click to both triggers within each item
    item.querySelectorAll('#sideViewTrigger, .side-view__container img').forEach((trigger) => {
      trigger.addEventListener('click', function (e) {        
        // Toggle the side view container inside this item
        item.querySelector('.side-view__container')?.toggleAttribute('hidden');
      });
    });
  
    // Zoom trigger (unchanged)
    item.querySelector('#zoomTrigger')?.addEventListener('click', function () {
      document.querySelector('.img-zoom-result')?.toggleAttribute('hidden');
      imageZoom(item, 'myresult', 2);
    });
  });
}

function markUnavailableVariants() {
  const productData = JSON.parse(document.getElementById('ProductData').textContent);  
  if (!productData?.variants) return;

  let availableColorsCount = 0;  

  productData.variants.forEach((variant) => {
    const metafield = variant.metafields["jmm.display_on_website"];
    const isUnavailable = !metafield || metafield.active === 'FALSE' || metafield.active === '';    

    if (isUnavailable) {
      const handle = metafield.variant_title;
      const matchingElements = document.querySelectorAll(`[data-value-handle="${handle}"]`);      

      matchingElements.forEach((el) => {        
        el.classList.add('unavailable-on-website');
      });
    } else {
      availableColorsCount ++;
        if(document.getElementById('AvaliableColorsSize')) {
          document.getElementById('AvaliableColorsSize').textContent = availableColorsCount;
        }      
    }
  });

  // Auto-select only remaining available variant, if there is exactly one
  const availableVariants = document.querySelectorAll('input[type="radio"].variant-option:not(.unavailable-on-website)');
  if (availableVariants.length === 1) {
    availableVariants[0].checked = true;    
    availableVariants[0].dispatchEvent(new Event('change', { bubbles: true }));
  }
}

// Update euro price
document.querySelectorAll('.cart-total').forEach(el => {
  if (el.textContent.includes('€')) {
    el.textContent = el.textContent
      .replace(/€\s*/g, '')
      .replace(/,00(?!\d)/g, '');
  }
});
